import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import MultipleMenuSection from '../MultipleMenuSection'

import { getIDs, getNames } from '../../helpers/parse'
import { selectTeams, fetchTeams } from '@SonarCX/slices/teamsSlice'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'

type TeamFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const TeamFilter: React.FC<TeamFilterProps> = props => {
  const dispatch = useAppDispatch()

  const { teams, loaded, loading } = useAppSelector(selectTeams)

  const { state, handleChange } = useTaskFilters()

  // Fetch teams if not loaded
  React.useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchTeams())
    }
  }, [loaded, loading, dispatch])

  return (
    <MultipleMenuSection
      title='Teams'
      options={getIDs(teams)}
      value={state.teamValue}
      setValue={handleChange('teamValue')}
      transform={getNames(teams)}
      unassignedOpt='All Teams'
      {...props}
    />
  )
}

export default TeamFilter
